module.exports = __webpack_public_path__ + "static/media/drop-down-p.976bb5c7.svg";